import { FunctionComponent } from "react";
import userICon from "../../assets/task/uses-icon.svg";
import deleteIcon from "../../assets/task/delete_viewidea4icons.svg";
import { useNavigate } from "react-router-dom";

interface HighPriorityIdeasProps {
    hp: any;
    onDelete: (id: string) => void;
    currentUserId?: string;
}

const HighPriorityIdeas: FunctionComponent<HighPriorityIdeasProps> = ({
    hp,
    onDelete,
    currentUserId,
}) => {
    const navigate = useNavigate()

    function handleIdeaClick(ideaID: string) {
        navigate('/view_idea', {
            state: {
                ideaID: ideaID
            }
        })
    }

    const handleDelete = (e: React.MouseEvent) => {
        e.stopPropagation();
        onDelete(hp?.id);
    };

    // Check if current user can delete (creator or employee ID 1000099)
    const canDelete = currentUserId && (
        hp?.created_by == currentUserId || 
        currentUserId == "1000099"
    );

    return (
        <div
            className="testing-section-dv self-stretch shadow-[0px_4px_4px_rgba(0,_0,_0,_0.25)] rounded bg-white border-whitesmoke border-solid border-[1px] box-border flex flex-col items-start justify-start p-2 gap-2 cursor-pointer overflow-visible" // Added cursor-pointer and overflow-visible
            onClick={() => handleIdeaClick(hp?.id)}
        >
            <div className="self-stretch rounded bg-antiquewhite-testing inner_testing-section-dv border-orange border-solid border-[1px] flex flex-row items-start justify-between p-2 gap-2.5 text-lg relative"> {/* Changed justify-center to justify-between and added relative */}
                <b className="flex-1 relative darktext-black">{hp?.project_name}</b>
                {canDelete && (
                    <img
                        className="w-5 h-5 relative cursor-pointer hover:opacity-70 transition-opacity dark-white-img"
                        alt="Delete"
                        src={deleteIcon}
                        onClick={handleDelete}
                    />
                )}
            </div>
            <hr className="bdr-custom-taskcrad" />

            <div className="idea_details-blog w-full">
                <p className="font-bold my-0 text-black-dv mb-2">{hp?.title}</p>
                {hp?.outcome_name && (
                    <div className="flex items-center gap-2 mb-2">
                        <span className="text-xs font-semibold text-gray-600 dark:text-gray-400">Outcome:</span>
                        <span className="text-xs bg-red-100 dark:bg-red-900 text-red-800 dark:text-red-200 px-2 py-1 rounded-full">{hp?.outcome_name}</span>
                    </div>
                )}
                {hp?.goal_for && (
                    <div className="flex items-center gap-2">
                        <span className="text-xs font-semibold text-gray-600 dark:text-gray-400">Goal For:</span>
                        <span className="text-xs bg-blue-100 dark:bg-blue-900 text-blue-800 dark:text-blue-200 px-2 py-1 rounded-full">{hp?.goal_for}</span>
                    </div>
                )}
            </div>

            {hp && hp?.skills?.length > 0 && (
                <div className="self-stretch flex w-full px-2">
                    <div className="self-stretch flex flex-col items-start w-full">
                        <p className="dark:text-white font-semibold text-black mb-1">Skills</p>
                        <div className="self-stretch flex items-start flex-wrap content-start gap-[8px] w-full">
                            {hp?.skills?.slice(0, 2).map((skill: any) => (
                                <div key={skill?.skill_id} className="bg-white overflow-hidden rounded-[100px] viewbg-dv right_status_clockout justify-center py-1 px-2 text-sm text-white flex flex-col items-start py-num-0 pl-num-0 pr-num-8">
                                    <div className="self-stretch flex flex-col items-start py-num-4 px-num-8">
                                        <div className="relative font-semibold p-purple-clr-dv">{skill?.skill_name}</div>
                                    </div>
                                </div>
                            ))}
                            {hp?.skills?.length > 2 && (
                                <div className="relative group inline-block z-10">
                                    <div className="bg-white overflow-hidden rounded-[100px] viewbg-dv right_status_clockout justify-center py-1 px-2 text-sm text-white flex flex-col items-start py-num-0 pl-num-0 pr-num-8 cursor-pointer">
                                        <div className="self-stretch flex flex-col items-start py-num-4 px-num-8">
                                            <div className="relative font-semibold p-purple-clr-dv">+{hp?.skills?.length - 2}</div>
                                        </div>
                                    </div>
                                    {/* Hover Tooltip/List */}
                                    <div className="absolute bottom-full mb-2 left-0 hidden group-hover:block bg-white dark:bg-slate-800 shadow-lg rounded-lg p-2 w-48 z-[100]">
                                        <ul className="text-sm text-gray-700 dark:text-gray-200 max-h-40 overflow-y-auto">
                                            {hp?.skills?.slice(2).map((skill: any) => (
                                                <li
                                                    key={skill?.skill_id}
                                                    className="py-1 px-2 hover:bg-gray-100 dark:hover:bg-slate-700 rounded"
                                                >
                                                    {skill?.skill_name}
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            )}

            <div className="self-stretch flex flex-row items-center justify-between py-0 px-2 gap-0">
                <div className="flex flex-row items-center justify-center gap-1.5">
                    <img className="w-5 relative h-5 overflow-hidden shrink-0 cursor-pointer" alt="" src={userICon} />
                    <div className="relative">Follow By:</div>
                </div>

                <div className="relative group inline-block">
                    {/* Count */}
                    <div className="px-2 py-1 bg-gray-100 rounded-lg border text-sm cursor-pointer count-dark-bg-dv dark-countstatus">
                        {hp?.followers?.length || 0}
                    </div>

                    {/* Hover Tooltip/List */}
                    {hp?.followers?.length > 0 && (
                        <div className="absolute top-8 right-0 hidden group-hover:block bg-white dark:bg-slate-800 shadow-lg rounded-lg p-2 w-48 z-50">
                            <ul className="text-sm text-gray-700 dark:text-gray-200 max-h-40 overflow-y-auto">
                                {hp?.followers?.map((member: any, i: number) => (
                                    <li
                                        key={i}
                                        className="py-1 px-2 hover:bg-gray-100 dark:hover:bg-slate-700 rounded"
                                    >
                                        {member?.employee_name || `Member ${i + 1}`}
                                    </li>
                                ))}
                            </ul>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}

export default HighPriorityIdeas;